import {IconButton, MenuItem} from '@mui/material'
import {React} from 'common'
import {MenuIconByType} from 'constants/topMenu'
import {getLayoutDirection} from 'services/hooks'
import {useIsRtl} from 'store/Store'
import styled from 'styled-components'

const MobileMenuItem = ({onClick, type, text}) => {
    const isRtl = useIsRtl()

    return (
        <Container>
            <MenuItem onClick={onClick} dir={getLayoutDirection(isRtl)}>
                <IconButton
                    size="large"
                    aria-label="account of current user"
                    aria-controls="primary-search-account-menu"
                    aria-haspopup="true"
                    color="inherit">
                    {MenuIconByType?.[type]}
                </IconButton>
                <p>{text}</p>
            </MenuItem>
        </Container>
    )
}

export default MobileMenuItem

const Container = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
`
